import { MNSproCloudApi } from '..';
import { Room } from '../api/v2';

export class ResourceV2Service {
  static async getAllRooms(
    authToken: string,
    organizationId: string,
  ): Promise<Room[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ResourcesApiFactory(config);
    const result = await api.getAllRooms(organizationId);
    return result.data;
  }
}
